import React from 'react';
import clsx from 'clsx';

interface Props {
  tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  children: React.ReactNode;
  className?: string;
  type: 'section_title' | 'article_title' | 'paragraph' | 'article_page_title';
}

const Text: React.FC<Props> = ({children, tag = 'h6', className, type}) => {
  const Component = tag;
  const typeStyles = {
    section_title: 'text-xl font-bold uppercase tracking-wide',
    article_title: 'text-md md:text-[20px] md:leading-[30px] font-semibold',
    article_page_title: 'text-xl',
    paragraph: 'text-md md:text-lg !leading-snug font-normal',
  };
  return (
    <Component className={clsx([className, typeStyles[type]])}>
      {children}
    </Component>
  );
};

export default Text;
